import React, { forwardRef } from 'react';

export const HeadCell = forwardRef(({ children, rootProps, innerProps, ...rest }, ref) => {
  return (
    <th {...rootProps} {...rest} ref={ref}>
      <div {...innerProps}>{children}</div>
    </th>
  );
});
